/**
 * @description defines routes for the FAQ page
 */

import React from 'react';

import Faq from '@seccon/pages/faq';

export default [
  {
    path: '/employee/faqs',
    element: (
      <Faq />
    )
  }
];
